import { render, staticRenderFns } from "./SetPublishingPicSource.vue?vue&type=template&id=02840d85"
import script from "./SetPublishingPicSource.vue?vue&type=script&lang=js"
export * from "./SetPublishingPicSource.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports